import { Component, OnInit } from '@angular/core';
import { TranslateServiceService } from '../services/translate-service.service';
import { ApiConnectionService } from '../services/api-connection.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-status-page',
  templateUrl: './status-page.component.html',
  styleUrls: [
    './status-page.component.scss',
    '../runner/runner.component.scss'
  ]
})
export class StatusPageComponent implements OnInit {

  text: any = {
    donor_info_section: {},
    invoice_section: {}
  };
  notCurrentLanguage: string;
  currentLanguageNav: string = "es";
  messageDonor: boolean = true;
  logoRace: string;
  goalBarBg: string;
  thanksText: string;
  errText: string;
  arePageReady: boolean = false;
  donorStatus: boolean = false;
  fiscalData: boolean;

  constructor(
    private translateService: TranslateServiceService,
    private apiService: ApiConnectionService,
    private router: Router
  ) {
    let _ = this;
    _.getCurrentLanguage();
  }

  async ngOnInit() {
    let _ = this;
    await _.getQuantities();
    _.getDonorStatus();
  }

  getDonorStatus(){
    let _ = this;
    let donorStatus = _.router.url.split('/');
    let errText = _.router.url.split('/')[6];
    _.errText = decodeURI(errText).split('_').join(' ');
    if(donorStatus[4] === 'true'){
      _.donorStatus = true;
    }
  }

  getCurrentLanguage() {
    let _ = this;
    let isEN = _.translateService.getCurrentLanguage() === 'EN';
    _.translateService.getJSON("assets/translations/runner.translations.json")
      .subscribe((res) => {
        if(isEN){
          _.text = res.english;
          _.notCurrentLanguage = 'ES';
          _.currentLanguageNav = 'en';
        }else{
          _.text = res.spanish;
          _.notCurrentLanguage = 'EN';
          _.currentLanguageNav = 'es';
        }
      });
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');

    return raceName[4];
  }

  getQuantities(){
    let _ = this;
    let conditions = {
      "conditions":{
        "race_url": _.getRaceName(),
        "active": true,
      },
      "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      _.messageDonor = data['results'][0].message_donor;
      _.logoRace = data['results'][0].design.images.logo_header;
      _.goalBarBg = data['results'][0].design.color.secundary;
      setTimeout(() => {
        _.arePageReady = true;
      }, 1000)
      if(_.currentLanguageNav == 'es'){
        _.thanksText = data['results'][0].design.thanks.es.message;
        return;
      }
      _.thanksText = data['results'][0].design.thanks.en.message;
    })
  }

  goToHome(){
    let _ = this;
    location.href = '/' + _.getMerchant() + '/' + _.getRaceName();
  }
}
